import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getDatiCodiceFiscale(codiceFiscale,apiPath) {
    return (dispatch) => {
        API.getAxios(apiPath).get(`/anagrafica/cf/${codiceFiscale}/controllo`)
        .then(response => { 
            dispatch({ type: actionTypes.SALVA_DATI_CODICE_FISCALE, payload: response.data});
            dispatch({ type: actionTypes.LOADING_CF_FALSE });
        })
        .catch(errore => {
            dispatch({ type: actionTypes.SALVA_DATI_CODICE_FISCALE, payload: errore.response.data});
            dispatch({ type: actionTypes.LOADING_CF_FALSE });
        })
    };
}

export default getDatiCodiceFiscale;